module.exports = __webpack_public_path__ + "static/media/Landing-page-bg.3a536dbd.png";